import {
  FETCHING_GENERATED_REPORT,
  FETCHING_GENERATED_REPORT_SUCCEEDED,
  FETCHING_GENERATED_REPORT_FAILED,
  GENERATING_REPORT_REQUEST,
  GENERATING_REPORT_REQUEST_SUCCEEDED,
  GENERATING_REPORT_REQUEST_FAILED
} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";

import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const GENERATE_REPORT_BASE_URL = `${API_URL}/api/1.0/accounts`;

/** fetch shares */
export const fetchGeneratedReport = createAction(FETCHING_GENERATED_REPORT);
const fetchingGeneratedReportSucceeded = createAction(FETCHING_GENERATED_REPORT_SUCCEEDED);
const fetchingGeneratedReportFailed = createAction(FETCHING_GENERATED_REPORT_FAILED);

function* fetchGeneratedReportSaga(action) {
  let { page, limit, filters } = action.payload;

  let url = buildUrl(GENERATE_REPORT_BASE_URL, { path: `/user-reports-list` });
  const fetchGeneratedReportAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: { page, limit },
      data: filters
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchGeneratedReportAPI);
    yield put(fetchingGeneratedReportSucceeded(response));
  } catch (error) {
    yield put(fetchingGeneratedReportFailed(error));
  }
}

export const generateReport = createAction(GENERATING_REPORT_REQUEST);
const generatingReportSucceeded = createAction(GENERATING_REPORT_REQUEST_SUCCEEDED);
const generatingReportFailed = createAction(GENERATING_REPORT_REQUEST_FAILED);

function* generatingReportSaga(action) {
  
  let { report } = action.payload;
  let url = buildUrl(GENERATE_REPORT_BASE_URL, { path: "/user-report" });

  const generateReportAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: report,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(generateReportAPI);
    yield put(generatingReportSucceeded(response));
  } catch (error) {
    yield put(generatingReportFailed(error));
  }
}

export default function* generateReportSaga() {
  yield takeLatest(FETCHING_GENERATED_REPORT, fetchGeneratedReportSaga);
  yield takeLatest(GENERATING_REPORT_REQUEST, generatingReportSaga);
}
